import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import styles from "./Footer.module.css";

/**
 * Shared public-facing footer used across landing pages (homepage, portfolio, etc.).
 *
 * Props
 * ─────
 * @param {string|null}  logoSrc        — Resolved logo URL (`null` while loading → skeleton)
 * @param {function}     [onHomeClick]  — Optional click handler for the Home link
 *                                        (e.g. scroll-to-hero on the homepage)
 * @param {string}       [portfolioHref="/projects"] — Portfolio link href
 *                                        (homepage gates this behind auth)
 * @param {function}     onFaqClick     — Click handler for FAQ nav item
 * @param {function}     onContactClick — Click handler for Contact nav item
 * @param {string}       [className]    — Optional extra CSS class on the outer <footer>
 */
const Footer = ({
  logoSrc,
  onHomeClick,
  portfolioHref = "/projects",
  onFaqClick,
  onContactClick,
  className,
}) => {
  return (
    <footer
      className={`${styles["landing-footer"]}${className ? ` ${className}` : ""}`}
    >
      <div className={styles["footer-content"]}>
        {/* ── Logo ── */}
        <div className={styles["footer-logo"]}>
          <div className={styles["footer-brand-row"]}>
            {logoSrc === null ? (
              <div
                style={{
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#333",
                  borderRadius: "4px",
                }}
              />
            ) : (
              <img src={logoSrc} alt="WebTwin logo" />
            )}
          </div>
        </div>

        {/* ── Nav links ── */}
        <div className={styles["footer-links"]}>
          <div className={styles["footer-nav-main"]}>
            <Link to="/" onClick={onHomeClick}>
              Home
            </Link>
            <Link to={portfolioHref}>Portfolio</Link>
            <span onClick={onFaqClick}>FAQ</span>
            <a href="mailto:developer@saecons.com">Contact</a>
          </div>
          <div className={styles["footer-nav-legal"]}>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          </div>
        </div>

        {/* ── Social icons ── */}
        <div className={styles["footer-contact"]}>
          {/* <span>contact@Web-Twin.com</span> */}
          <div className={styles["footer-socials"]}>
            <FontAwesomeIcon icon={faLinkedinIn} />
            <FontAwesomeIcon icon={faXTwitter} />
          </div>
        </div>
      </div>

      <div className={styles["footer-bottom"]}>
        <p>© 2026 Web-Twin.com All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
